import { Injectable, Injector } from '@angular/core';
import { ListHelperService, ProfileService, StoreService, LocalesService, HttpDataService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';
import { DateTime } from 'luxon';

@Injectable()
export class EmailsListService extends HttpDataService {
  public userRole: any;

  constructor(
    public translate: TranslateService,
    public profileService: ProfileService,
    public listHelper: ListHelperService,
    public locales: LocalesService,
    protected injector: Injector
  ) {
    super(injector, '/messages');
    profileService.getLoggedUserRole$().subscribe((userRole) => (this.userRole = userRole));
  }

  async getDatasource(listId, options: any = {}) {
    const dataSource = new TableDatasource({
      sort: '-created_at',
      columns: this.getColumns({ timezone: options.timezone }),
      load: (props) => this.customFetch(props, dataSource),
      storeState: {
        enabled: true,
        key: `${listId}_${this.userRole.name}`
      },
      ...options
    });
    await dataSource.refreshData();
    StoreService.create(listId, dataSource);
    return dataSource;
  }

  customFetch({ page, limit, sort, search, filters, aggregates, populate }, dataSource: TableDatasource) {
    const { entityId, groupId, matchId, ...$filterValues } = filters;
    const $filter = this.listHelper.buildFilterString($filterValues, dataSource, this.getCustomFilters());

    const paginationOptions = {
      page,
      limit,
      sort,
      search,
      aggregates,
      populate,
      'recipient.entityId': entityId,
      groupId,
      matchId,
      $filter
    };
    return this.fetch(paginationOptions).then((response) => response);
  }

  getColumns({ timezone = 'utc', sortable = true }) {
    const columns = [
      {
        source: 'recipient.email',
        label: this.translate.instant('emails.email'),
        sortable: sortable
      },
      {
        source: 'created_at',
        label: this.translate.instant('emails.sent'),
        sortable: sortable,
        dataType: DataTypes.datetime,
        valueParser: (value, email) => {
          const format = DateTime.DATETIME_MED_WITH_SECONDS;
          return this.listHelper.parseDate(value, timezone, format) + ' (' + timezone + ')';
        }
      },
      {
        source: 'type',
        label: this.translate.instant('nouns.type'),
        sortable: sortable,
        valueParser: (value) => this.translate.instant('mail.types.' + value)
      },
      {
        source: 'status',
        label: this.translate.instant('nouns.status'),
        sortable: sortable
      }
    ];
    return columns;
  }

  getCustomFilters() {
    return {};
  }
}
